import { ChangeDetectionStrategy, Component, OnChanges, SimpleChanges } from '@angular/core';
import { BaseSmartFilterFormComponent } from '../base-smart-filter-form';
import { ProductAddEditSmartFilterFormViewModel } from './product-add-edit-smart-filter-form-view-model';

@Component({
  selector: 'app-product-add-edit-smart-filter-form',
  templateUrl: './product-add-edit-smart-filter-form.component.html',
  styleUrls: ['./product-add-edit-smart-filter-form.component.scss'],
  providers: [ProductAddEditSmartFilterFormViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ProductAddEditSmartFilterFormComponent extends BaseSmartFilterFormComponent implements OnChanges {
  constructor(public viewModel: ProductAddEditSmartFilterFormViewModel) {
    super();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.bindTo) {
      this.viewModel.connectToSmartFilter(this.bindTo);
      this.viewModel.connectToSelectedProductType(this.bindTo.productType);
    }
    if (changes.isEditing) this.viewModel.connectToIsEditing(this.isEditing);
    if (changes.isViewOnly) this.viewModel.connectToIsViewOnly(this.isViewOnly);
  }
}
